/** Original architectural engraving, shared by the lobby and table identity. */
export function RecursiveRoom() {
  return (
    <svg viewBox="0 0 600 640" fill="none" aria-hidden="true" className="recursive-room">
      <defs>
        <pattern id="engraving" width="6" height="6" patternUnits="userSpaceOnUse">
          <path d="M0 6L6 0" stroke="currentColor" strokeWidth=".5" opacity=".28" />
        </pattern>
      </defs>
      <circle cx="300" cy="279" r="219" stroke="currentColor" opacity=".2" />
      <circle cx="300" cy="279" r="231" stroke="currentColor" strokeDasharray="1 9" opacity=".4" />
      <path d="M70 478V244a230 230 0 0 1 460 0v234L300 606Z" fill="url(#engraving)" stroke="currentColor" />
      <path d="M105 458V248a195 195 0 0 1 390 0v210L300 565Z" fill="var(--art-bg)" stroke="currentColor" />
      {[0,1,2,3,4,5,6].map(i => (
        <g key={i} transform={`translate(${i * 24} ${i * 29}) scale(${1-i*.075})`}>
          <path d="M138 444V257a162 162 0 0 1 324 0v187" stroke="currentColor" opacity={1-i*.09} />
          <path d="M149 439V258a151 151 0 0 1 302 0v181" stroke="currentColor" opacity=".3" />
        </g>
      ))}
      <path d="M105 458L300 355L495 458L300 565Z" fill="var(--art-bg)" stroke="currentColor" />
      {[0,1,2,3,4,5,6,7,8].map(i => <g key={i} opacity=".55">
        <path d={`M${105+i*24.375} ${458-i*12.875}L${300+i*24.375} ${565-i*13.375}`} stroke="currentColor" />
        <path d={`M${105+i*24.375} ${458+i*13.375}L${300+i*24.375} ${355+i*12.875}`} stroke="currentColor" />
      </g>)}
      <path d="M234 427v-67h22v-17h22v-17h22v-17h22v-17h22v-17h22v110L300 462Z" fill="var(--art-bg)" stroke="currentColor" />
      {[0,1,2,3,4,5].map(i => <path key={i} d={`M${234+i*22} ${360-i*17}l66 35v67`} stroke="currentColor" opacity=".7" />)}
      <path d="M300 171c-16 19-43 35-43 56 0 24 29 28 40 10-1 17-6 27-14 35h34c-8-8-13-18-14-35 11 18 40 14 40-10 0-21-27-37-43-56Z" fill="currentColor" />
      <path d="M40 279h40m440 0h40M300 24v30M300 602v25" stroke="currentColor" />
      <circle cx="300" cy="610" r="4" fill="currentColor" />
    </svg>
  )
}
